const footerLinks = [
  { label: 'Home', href: '#home' },
  { label: 'About', href: '#about' },
  { label: 'Services', href: '#services' },
  { label: 'Listings', href: '#listings' },
  { label: 'Testimonials', href: '#testimonials' },
  { label: 'Contact', href: '#contact' },
];

const serviceList = [
  'Residential Home Sales · 주택 매매',
  'Commercial Real Estate · 상업용 부동산',
  'Investment Properties · 투자 부동산',
  'Buyer Representation · 바이어 에이전트',
  'Seller Representation · 셀러 에이전트',
  'Relocation Services · 이주 서비스',
];

export default function Footer() {
  const handleNav = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-[#2C2013] text-white">
      {/* Top Bar */}
      <div className="border-b border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-12 grid md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="lg:col-span-1">
            <img
              src="https://public.readdy.ai/ai/img_res/ad91bbaa-5738-4ac8-829f-abe55c8dec23.png"
              alt="김산 부동산 Shawn Kim Real Estate"
              className="h-14 w-auto object-contain mb-4"
            />
            <p className="text-white/55 text-xs leading-relaxed mt-2">
              Your trusted real estate broker in Atlanta, Duluth &amp; Suwanee, Georgia.
            </p>
            <p className="text-white/40 text-xs leading-relaxed mt-1">
              애틀란타, 둘루스, 스와니 부동산 전문
            </p>
            <a
              href="tel:4049340670"
              className="mt-4 inline-flex items-center gap-2 text-[#D4AF70] text-sm font-semibold hover:text-white transition-colors cursor-pointer"
            >
              <i className="ri-phone-fill"></i>
              (404) 934-0670
            </a>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-white text-sm font-bold mb-4 tracking-wide">Quick Links</h4>
            <ul className="space-y-2.5">
              {footerLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => { e.preventDefault(); handleNav(link.href); }}
                    className="text-white/55 hover:text-[#D4AF70] text-xs transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white text-sm font-bold mb-4 tracking-wide">Services</h4>
            <ul className="space-y-2.5">
              {serviceList.map((s) => (
                <li key={s}>
                  <span className="text-white/55 text-xs">{s}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Office Info */}
          <div>
            <h4 className="text-white text-sm font-bold mb-4 tracking-wide">Office</h4>
            <div className="space-y-3 text-xs text-white/55">
              <div className="flex items-start gap-2">
                <i className="ri-map-pin-2-fill text-[#D4AF70] mt-0.5"></i>
                <span>3790 Satellite Blvd #102<br />Duluth, GA 30096</span>
              </div>
              <div className="flex items-start gap-2">
                <i className="ri-time-fill text-[#D4AF70] mt-0.5"></i>
                <div>
                  <div>Mon–Fri: 9 AM – 6 PM</div>
                  <div>Saturday: 9 AM – 6 PM</div>
                  <div>Sunday: 1 PM – 6 PM</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-phone-fill text-[#D4AF70]"></i>
                <a href="tel:4049340670" className="hover:text-white transition-colors cursor-pointer">(404) 934-0670</a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/35">
        <span>© {new Date().getFullYear()} 김산 부동산 · Shawn Kim Real Estate. All rights reserved.</span>
        <span>Atlanta · Duluth · Suwanee, Georgia · Licensed Real Estate Broker</span>
      </div>
    </footer>
  );
}
